export default __webpack_public_path__ + "static/media/logo.9825c7ab.png";